import { clsx, type ClassValue } from 'clsx';

/** Fusionne des classes conditionnelles (utilitaire léger). */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
